var React = require('react');

function CloseQuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.565821 34.25C3.56582 34.05 5.66582 32.65 6.86582 30.05C8.06582 27.45 8.66582 23.25 8.66582 17.45H0.715821V0.499991H18.2658V15.05C18.2658 23.15 17.1158 29.3 14.8158 33.5C12.5158 37.7 8.71582 39.95 3.41582 40.25L0.565821 34.25ZM26.9658 34.25C29.9658 34.05 32.0658 32.65 33.2658 30.05C34.4658 27.45 35.0658 23.25 35.0658 17.45H27.1158V0.499991H44.6658V15.05C44.6658 23.15 43.5158 29.3 41.2158 33.5C38.9158 37.7 35.1158 39.95 29.8158 40.25L26.9658 34.25Z","fill":"#333333"}));
}

CloseQuoteInline.defaultProps = {"width":"45","height":"41","viewBox":"0 0 45 41","fill":"none"};

module.exports = CloseQuoteInline;

CloseQuoteInline.default = CloseQuoteInline;
